// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shrimp"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10 12C5.58172 12 2 9.41828 2 5V4H13H14C15.9635 4 17.7449 4.69313 19.137 5.86687C20.8775 7.33434 22 9.54508 22 12C22 14.4727 20.8951 16.6692 19.1328 18.1367C17.746 19.2914 15.9457 20 14 20H7V19C7 17.3431 8.34315 16 10 16H13V12L10 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 12V16M13 12L10 12C5.58172 12 2 9.41828 2 5V4H13M13 12L21.45 12M13 12L18.9452 6.05855M13 12L18.9411 17.9449M13 4V16M13 4H14C15.9635 4 17.7449 4.69313 19.137 5.86687C20.8775 7.33434 22 9.54508 22 12C22 14.4727 20.8951 16.6692 19.1328 18.1367C17.746 19.2914 15.9457 20 14 20H7V19C7 17.3431 8.34315 16 10 16H13M13 20V16M7.99805 6.99805H8.00195V7.00195H7.99805V6.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ShrimpIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shrimp',
    ref,
    icon: element,
  },
));

ShrimpIcon.displayName = 'ShrimpIcon';

export default ShrimpIcon;
